import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import { isApiResponse, isReportAccess, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var minDate = new Date('2020-02-01');
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
var GinieTraTable='';
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
var aplloClient = ["IAPO0213","IAPO0238","I00585","IAPO0274","IAPO0303","I00937","IAPO0392","I03011","APO0454","I03274","IAPO0393","I03010","SIND0192","SIND0257","S00595","IAPO0213","IAPO0260","I00628","IAPO0170","IAPO0196","I00538","IAPO0213","IAPO0398","I03013","IAPO0223","IAPO0246","I00616","SAPO0202","SAPO0269","S01388","IAPO0466","I03283","SIND0192","SIND0257","S00649","IAPO0394","I03012","IAPO0221","IAPO0244","I00615"]

class GenieTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[{value:'CMER0002', label: 'Innoviti Payment Solutions Pvt. Ltd.'}],
            chainList:[],
            merchantID:['CMER0002'],
            chainID:'',
            storeID:'',
            merchantValue:[{value:'CMER0002', label: 'Innoviti Payment Solutions Pvt. Ltd.'}],
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void: 1,
            model_visible : false,
            file_url: '',
            rfile: '',
            cardGradeLists:[],
            cardGradeValue:'',
            cardGradeIDs:'',
            schemeLists:[],
            schemeValue:'',
            schemeIDs:'',
            cardTypeLists:[],
            cardTypeValue:'',
            cardTypeIDs:'',
            txnissuerLists:[],
            txnissuerValue:'',
            txnissuerIDs:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tenderModeIDs:'',
            tenderModeValue:'',
            txnTypeLists: [],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: false,
            dateFromLimit: start_date_limit,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            slipData:'',
            isSettledLists: [],
            isSettledIDs: '',
            isSettledValue: null,
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            productTypeLists: [],
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
            serviceTypeLists: [],
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            communicationIdList:[],
            communicationIdValue: null,
            communicationIdIds:'',
            fetch_data:false,
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:'',
        }
        this.close = this.close.bind(this);
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "ubc_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }
        if(decoded.object_type==='Acquiring Bank'){
            this.setState({
                acqBankIds: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {
        const { listOpen } = this.state;
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }


    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType
        });
        //this._getAllMerchants();
        this._get_acq_banks();
        //this._get_issuing_banks();
        this._get_city();
        this._get_card_grade();
        this._get_scheme();
        this._get_card_type();
        this._txn_issuer_bank();
        this.communication_id();
        this.getIndustryCategory();
        //this.ci_utid('','','','','');
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            this.changeMerchant('', this.state.merchantValue);
            this._get_filtered_genie_transaction_report(decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: ['CMER0002'],
                search_type:'merchant',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'Total EMI', label: 'Total EMI'},
                    {value: 'True EMI', label: 'G.E.N.I.E'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                    {value: 'Partner EMI',label: 'Partner EMI'},
                ],

                search_object_code: ['CMER0002'],
            })
            
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this._get_filtered_genie_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                ],

                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this._get_filtered_genie_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                ],

                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this._get_filtered_genie_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'genie_txn_report','sparcs')

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("genie_daily_transaction")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    refressOnDateChange(){
        this._get_scheme();
        this._get_card_type();
        this._txn_issuer_bank();
        //this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID);
        this.setState({
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs: '',
            // ciutidValue: [],
            // ciutidIds: '',
        });
    }

    ci_utid(mid,cid,sid,is_search, search_value) {
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true

        })
        axios.post(config.get('API_URL') + '/reports/get-genie-utid/', {
                mid: mid,
                cid: cid,
                sid: sid
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            let utidList = [];
            this.setState({ciutidIds:''});
            response.data.data.map((ci_utid,index) => {
                utidList.push({value: ci_utid.utid, label: ci_utid.utid})
            });
            this.setState({
                ciutidList:utidList,
                is_utid_loading: false

            })
        });

    }

    filterList(e){
        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }

//     changeUtid(utid,checked_item, e){
//         let item_list = this.state.ciutidIds
//         let checked_list = utid;
//         //console.log(checked_list);
//         if(checked_item===false) {
//             const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
//             this.setState({
//                 ciutidIds: [...this.state.ciutidIds,  utid],
//                 isChange: true,
//                 ciutidList: newData
//             });
//
//         } else{
//             let index = item_list.indexOf(checked_list);
//             if (index > -1) {
//                 item_list.splice(index, 1);
//                 if(item_list.length<1) {
//                     item_list='';
//                 }
//                 this.setState({
//                     ciutidIds: item_list,
//                     isChange: true
//                 })
//             }
//         }

//
//         if (e.target.type === 'checkbox') {
//             e.stopPropagation();
//         }
//     }

    _txn_issuer_bank(){
        axios.post(config.get('API_URL')+'/reports/txn-daily-issuer-bank/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                txnissuerLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_issure, index) => {
                    this.state.txnissuerLists.push({value: txn_issure.issuing_bank_name, label: txn_issure.issuing_bank_name})
                });
            }
        });
    }
    changeProductType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        var is_enable = compareValues(value, this.state.active_product);
        this.setState({
            productTypeIDs:value,
            productTypeValue:optionSelected,
            isChange: is_enable
        });
    }
    changeServiceType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            serviceTypeIDs:value,
            serviceTypeValue:optionSelected,
            isChange: true
        });
    }
       communication_id(){
        axios.get(config.get('API_URL')+'/reports/communication_id/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((communication_id, index) => {
                    this.state.communicationIdList.push({value: communication_id.communication_id, label: communication_id.display_name})
                });
            }
        });
    }
    changeCommId(optionSelected){
        let value='';
        let commArray = [];
        if(optionSelected.length<1){
            value = null;
            commArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                commArray.push(mids.value)
                var index = this.state.communicationIdList.findIndex(obj => obj.value==mids.value);
                this.state.communicationIdList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(commArray, this.state.active_communication_id);
        this.setState({
            communicationIdIds:commArray,
            communicationIdValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_live_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.coReMgsIds, this.state.txnStatusIds, this.state.ciutidIds, commArray, this.state.co_reason_codeIds,this.state.ci_inno_proCodeIds,this.state.ci_inno_posentrymodeIds,this.state.bo_bank_responcecodeIds);
    }
    change_issuer(optionSelected){
        let value='';
        let issuArray = [];
        if(optionSelected.length < 1){
            value = null;
            issuArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                issuArray.push(mids.value)
                var index = this.state.txnissuerLists.findIndex(obj => obj.value==mids.value);
                this.state.txnissuerLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(issuArray, this.state.active_issuer);
        this.setState({
            txnissuerIDs:issuArray,
            txnissuerValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, issuArray, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds,this.state.isSettledIDs, this.state.is_fallback);

    }
    _get_card_type(){
        axios.post(config.get('API_URL')+'/reports/txn-cardtype/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                cardTypeLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((credit_debit, index) => {
                    this.state.cardTypeLists.push({value: credit_debit.card_type, label: credit_debit.card_type})
                });
            }
        });
    }
    changeCardType(optionSelected){
        let value='';
        let ceditArray = [];
        if(optionSelected.length < 1){
            value = null;
            ceditArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                ceditArray.push(mids.value)
                var index = this.state.cardTypeLists.findIndex(obj => obj.value==mids.value);
                this.state.cardTypeLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(ceditArray, this.state.active_cedit_debit);
        this.setState({
            cardTypeIDs:ceditArray,
            cardTypeValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, ceditArray, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds,this.state.isSettledIDs, this.state.is_fallback);
    }
    _get_card_grade(){
        axios.post(config.get('API_URL')+'/reports/dcc-cardgrade/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((card_type, index) => {
                    this.state.cardGradeLists.push({value: card_type.card_type, label: card_type.card_type})
                });
            }
        });
    }
    changeCardGrade(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected.length < 1){
            value = null;
            catArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
                var index = this.state.cardGradeLists.findIndex(obj => obj.value==mids.value);
                this.state.cardGradeLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(catArray, this.state.active_card_grade);
        this.setState({
            cardGradeIDs:catArray,
            cardGradeValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, catArray, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs, this.state.is_fallback);
    }
    _get_scheme(){
        axios.post(config.get('API_URL')+'/reports/dcc-cardtype/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                schemeLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((card_type, index) => {
                    this.state.schemeLists.push({value: card_type.card_type, label: card_type.card_type})
                });
            }
        });
    }
    changeScheme(optionSelected){
        let value='';
        let schemeArray = [];
        if(optionSelected.length < 1){
            value = null;
            schemeArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.schemeLists.findIndex(obj => obj.value==mids.value);
                this.state.schemeLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(schemeArray, this.state.active_scheme);
        this.setState({
            schemeIDs:schemeArray,
            schemeValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, schemeArray, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds,this.state.isSettledIDs, this.state.is_fallback);
    }
    _downLoadGenieTraReportCheck (e){
    let is_txn = false;
    if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
    {
       is_txn = true;
    }
    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
    && this.state.cityIds==='' && this.state.tenderModeIDs==='' && this.state.txnissuerIDs==='' && this.state.schemeIDs===''
    && this.state.cardTypeIDs==='' && this.state.isSettledIDs==='' && this.state.productTypeIDs==='' && this.state.serviceTypeIDs==='' && is_txn ===true
    && this.state.communicationIdIds===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this._downLoadGenieTraReport();
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
        this._downLoadGenieTraReport()
        }
    }
    _downLoadGenieTraReport (e){
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
            alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            is_void: this.state.is_void,
            download: true,
            card_grade: this.state.cardGradeIDs,
            scheme: this.state.schemeIDs,
            cedit_debit: this.state.cardTypeIDs,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
            issuer: this.state.txnissuerIDs,
            txn_type: "",
            live_or_daily: "daily",
            is_settled: this.state.isSettledIDs,
            is_fallback: this.state.is_fallback,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            communication_id:this.state.communicationIdIds,
            industry_code: this.state.industryCategoryIds
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/genie-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyGenieTxnFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyGenieTxnFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'genie_transaction_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }

    _get_filtered_genie_transaction_report(object_type, object_code, event) {

        var that = this;
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var obj_code = this.state.object_code;
        

        disabledBody()

        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids:merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_is_void: this.state.is_void,
            active_card_grade: this.state.cardGradeIDs,
            active_scheme: this.state.schemeIDs,
            active_cedit_debit: this.state.cardTypeIDs,
            active_transaction_type: this.state.txnTypeIDs,
            active_utid: this.state.ciutidIds,
            active_tender_mode: this.state.tenderModeIDs,
            active_is_prim_id: this.state.is_prim_id,
            active_issuer: this.state.txnissuerIDs,
            active_is_settled: this.state.isSettledIDs,
            active_is_fallback: this.state.is_fallback,
            active_is_posbillinput: this.state.is_posbillinput
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            is_void: this.state.is_void,
            card_grade: this.state.cardGradeIDs,
            scheme: this.state.schemeIDs,
            cedit_debit: this.state.cardTypeIDs,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
            issuer: this.state.txnissuerIDs,
            txn_type: "",
            live_or_daily: "daily",
            is_settled: this.state.isSettledIDs,
            is_fallback: this.state.is_fallback,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            communication_id:this.state.communicationIdIds,
            industry_code: this.state.industryCategoryIds
        };
        if ($.fn.DataTable.isDataTable('#GinieTraTable')) {
            $('#GinieTraTable').DataTable().clear().destroy();
        }
        GinieTraTable = $('#GinieTraTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth":false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/genie-transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody();
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Merchant",  "width": "150px"},
                    {"data":"Chain",  "width": "150px"},
                    {"data":"Store",  "width": "150px"},
                    {"data":"Store Address 1", "width": "200px"},
                    {"data":"Store Address 2", "width": "200px"},
                    {"data": "City"},
                    {"data": "State", "width": "80px"},
                    {"data": "Product Amount"},
                    {"data": "Sale Amount"},
                    {"data": "Transaction Amount"},
                    {"data": "Loan Amount"},
                    {"data": "EMI Amount"},
                    {"data": "Instant Discount/Cashback"},
                    {"data": "No Cost EMI Amount"},
                    {"data": "Additional Cashback"},
                    {"data": "Genie Coupon Discount"},
                    {"data": "Transaction Date"},
                    {"data": "Transaction Time"},
                    {"data": "Btid"},
                    {"data": "Utid"},
                    {"data": "Card Number"},
                    {"data": "Bin No"},
                    {"data": "Acquiring Bank"},
                    {"data": "Issuer Bank"},
                    {"data": "Tender Mode"},
                    {"data": "Scheme"},
                    {"data": "Grade"},
                    {"data": "Credit/Debit"},
                    {"data": "RRN No"},
                    {"data": "Approval Code"},
                    {"data": "Merchant Invoice Number"},
                    {"data": "Batchsrl"},
                    {"data": "Invoice"},
                    {"data": "Bank Merchant Id"},
                    {"data":"Processing Code"},
                    {"data": "Transaction Type"},
                    {"data": "Card Holder Name"},
                    {"data": "Is DCC Transaction"},
                    {"data": "Is International Card"},
                    {"data": "Transaction Medium"},
                    {"data":"Software Version"},
                    {"data": "Terminal Serial Number"},
                    {"data": "Bill Invoice Number"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":"Brand"},
                    {"data":"Model"},
                    {"data":"Merchant SKU"},
                    {"data":"Category"},
                    {"data":"service type" , "width": "200px"},
                    {"data": "Innoviti Convenience Fee"},
                    {"data":"Industry Category"},
                ],
                "columnDefs": [


                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "200px",
                        "targets": 16
                    },
                    {
                        render: function (data, type, full, meta) {
                        if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,3,4]
                    }

                ]

            });



        
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = ['CMER0002'];
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });

        }
        var is_enable = compareValues(midArray, this.state.active_mids);

        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,

        });
        //this._get_filtered_genie_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, '', this.state.isSettledIDs,this.state.is_fallback);
        if(login_type==''){
            this.getChain(midArray, 'merchant', 'Merchant', ['CMER0002']);
            this.getStore(midArray, 'merchant', 'Merchant', ['CMER0002'],false,'');
        }
        this.ci_utid(midArray, '','',false,'');
    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });

        //this._get_filtered_genie_transaction_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, '', this.state.isSettledIDs,this.state.is_fallback);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }
        this.ci_utid(this.state.merchantID, cidArray, '',false,'');

    }
    changeUtid(optionSelected){
        let value='';
        let utidArray = [];
        if(optionSelected.length<1){
            value = null;
            utidArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                utidArray.push(mids.value)
                var index = this.state.ciutidList.findIndex(obj => obj.value==mids.value);
                this.state.ciutidList.move(index,0).join(',');
            });
        }
        this.setState({
            ciutidIds:utidArray,
            ciutidValue:optionSelected,
            isChange:true
        });

    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            is_chain_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

         setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, false, '');
        }.bind(this), 200);
    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        var is_enable = compareValues(acqBankArray, this.state.active_bids);
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs,this.state.is_fallback);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){
        let value='';
        let cityArray = [];
        if(optionSelected.length < 1){
            value = null;
            cityArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(cityArray, this.state.active_cityids);
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
            isChange: is_enable
        });
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs,this.state.is_fallback)
    }
    getIndustryCategory(){
        axios.get(config.get('API_URL')+'/filters/get-industry-category/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((cat, index) => {
                    this.state.industryCategoryList.push({value: cat.category_code, label: cat.category_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeIndustryCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected.length < 1){
            value = null;
            catArray='';
        }
        else{
            optionSelected.map((cat, i) => {
                catArray.push(cat.value)
                var index = this.state.industryCategoryList.findIndex(obj => obj.value==cat.value);
                this.state.industryCategoryList.move(index,0).join(',');
            });
        }

        this.setState({
            industryCategoryIds:catArray,
            industryCategoryValue:optionSelected,
            isChange: true
        });
    }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),

        });
        if(event.type=='apply') {
            var is_date_change = false;
            if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                is_date_change = false;
            } else {
                is_date_change = true;
            }
            this.setState({
                isChange: is_date_change
            })
            //     this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //         this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs,this.state.is_fallback)

            this.refressOnDateChange();
        }
    }
    handleCheckVoid(e)
    {
        var is_void = 1;
        if(e.target.checked===true){
            this.setState({ is_void:1})
        } else {
            this.setState({ is_void:0});
            is_void = 0;
        }
        //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs,this.state.is_fallback)

    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    handleCheckFallback(e) {
        var is_fallback = 1;
        if (e.target.checked === true) {
            this.setState({is_fallback: 1, isChange: true})
            //this._get_filtered_genie_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs, this.state.txnissuerIDs, this.state.tenderModeIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs, is_fallback)

            //GinieTraTable.columns(36).visible(true);
        } else {
            this.setState({is_fallback: 0, isChange: true});
            is_fallback = 0;
            GinieTraTable.columns(36).visible(false);
        }
        var is_enable = compareValues(is_fallback, this.state.active_is_fallback);
        this.setState({
            isChange: is_enable
        })

    }

    handleCheckPosBill(e) {
        var is_posbillinput = 1;
        if (e.target.checked === true) {
            this.setState({is_posbillinput: 1, isChange: true})

        } else {
            this.setState({is_posbillinput: 0, isChange: true});
            is_posbillinput = 0;
            // GinieTraTable.columns(36).visible(false);
        }
        var is_enable = compareValues(is_posbillinput, this.state.active_is_posbillinput);
        this.setState({
            isChange: is_enable
        })

    }

    handleCheckPrimId(e) {
        var is_prim_id = 1;
        if (e.target.checked === true) {
            this.setState({is_prim_id: 1, isChange: true})

        } else {
            this.setState({is_prim_id: 0, isChange: true});
            is_prim_id = 0;
            //GinieTraTable.columns(36).visible(false);
        }
        var is_enable = compareValues(is_prim_id, this.state.active_is_prim_id);
        this.setState({
            isChange: is_enable
        })

    }
    reset_all(e){
        if(this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true)
        {
        this.refs.serviceFilter.restServiceFilter();
        }
        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
            communicationIdValue: [],
            communicationIdIds:'',
            industryCategoryIds:'',
            industryCategoryValue: [],

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleService = (serviceData) =>{
        const value = serviceData === null ? '' : serviceData.value;
        this.setState({
            serviceTypeValue: serviceData,
            isChange: true,
            serviceTypeIDs:value,
        })
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            tenderModeValue:optionSelected,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isSettledValue:optionSelected,
            isChange: true
        });
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">G.E.N.I.E. Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                                 onEvent={this.handleEvent.bind(this)}
                                                                 maxDate={this.state.dateLimit}
                                                                 minDate={this.state.dateFromLimit}
                                                >
                                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                                    <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                           value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                                </DateRangePicker>
                                            </div>
                                            {this.state.merchant_list_box ===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <ReactMultiSelectCheckboxes name="merchants"
                                                                                isMulti
                                                                                isLoading={this.state.is_merchant_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.merchantValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeMerchant.bind(this,'')}
                                                                                options={this.state.merchantList}
                                                                                placeholderButtonLabel="Select [Merchant]"
                                                    />

                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.chain_list_box===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ReactMultiSelectCheckboxes name="chain"
                                                                                isMulti
                                                                                isLoading={this.state.is_chain_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.chainValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeChain.bind(this,'')}
                                                                                options={this.state.chainList}
                                                                                placeholderButtonLabel="Select [Chain]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.store_list_box===true?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <div className="dd-wrapper">
                                                        <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                            {this.state.storeID==''?
                                                                <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                                <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                            }

                                                            <i className="fa fa-angle-down"></i>
                                                        </div>
                                                        {this.state.storeListOpen ===true?
                                                            <div
                                                                role="list"
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <input
                                                                    className="dd-list-search-bar"
                                                                    placeholder="Search"
                                                                    onChange={(e) => this.storeFilterList(e)}
                                                                />
                                                                <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                                {/*<div className="dd-scroll-list">*/}
                                                                <ul className="dd-list">
                                                                    {this.state.is_store_loading===true?
                                                                        <li>
                                                                            <BeatLoader
                                                                                css={override}
                                                                                sizeUnit={"px"}
                                                                                size={5}
                                                                                color={'#666666'}
                                                                                loading={this.state.is_store_loading}
                                                                            />
                                                                        </li>: null}
                                                                    {store_lists}

                                                                </ul> </div>: null }
                                                        {/*</div>*/}
                                                    </div>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> UTID </label>
                                                    <ReactMultiSelectCheckboxes name="UTID"
                                                                                isMulti
                                                                                isLoading={this.state.is_utid_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.ciutidValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeUtid.bind(this)}
                                                                                options={this.state.ciutidList}
                                                                                placeholderButtonLabel="Select [UTID]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <ReactMultiSelectCheckboxes name="acqurier"
                                                                            isMulti
                                                                            value={this.state.acqBankValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.change_acq_banks.bind(this)}
                                                                            options={this.state.acqBankList}
                                                                            placeholderButtonLabel="Select [Acquirer]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*: null }*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Issuer:</label>
                                                <ReactMultiSelectCheckboxes name="issuer"
                                                                            isMulti
                                                                            value={this.state.txnissuerValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.change_issuer.bind(this)}
                                                                            options={this.state.txnissuerLists}
                                                                            placeholderButtonLabel="Select [issuer]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*<div className="col-md-3">*/}
                                            {/*    <label> Issuer: </label>*/}
                                            {/*    <Select name="issuer"*/}
                                            {/*            isMulti*/}
                                            {/*            value={this.state.issuerBankValue}*/}
                                            {/*            styles={customStyles} className="report-listbox"*/}
                                            {/*            isClearable={false}*/}
                                            {/*            onChange={this.changeChain.bind(this,'')}*/}
                                            {/*            options={this.state.issuerBankList}*/}
                                            {/*            placeholder="Select[Issuer]"*/}
                                            {/*    />*/}
                                            {/*    <div className="clearfix"></div>*/}
                                            {/*</div>*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> City: </label>
                                                <ReactMultiSelectCheckboxes name="city"
                                                                            isMulti
                                                                            value={this.state.cityValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeCity.bind(this)}
                                                                            options={this.state.cityLists}
                                                                            placeholderButtonLabel="Select [City]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Scheme: </label>
                                                <ReactMultiSelectCheckboxes name="scheme"
                                                                            isMulti
                                                                            value={this.state.schemeValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeScheme.bind(this)}
                                                                            options={this.state.schemeLists}
                                                                            placeholderButtonLabel="Select [Scheme]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Card Type: </label>
                                                <ReactMultiSelectCheckboxes name="cardType"
                                                                            isMulti
                                                                            value={this.state.cardTypeValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeCardType.bind(this)}
                                                                            options={this.state.cardTypeLists}
                                                                            placeholderButtonLabel="Select [Card Type]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Transaction Medium </label>
                                                <ReactMultiSelectCheckboxes name="communication_id"
                                                    isMulti
                                                    value={this.state.communicationIdValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeCommId.bind(this)}
                                                    options={this.state.communicationIdList}
                                                    placeholderButtonLabel="Select [Transaction Medium]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No' />
                                                 <div className="clearfix"></div>
                                                 <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Settled/Unsettled </label>
                                                <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                <ReactMultiSelectCheckboxes name="city"
                                                                            isMulti
                                                                            value={this.state.industryCategoryValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeIndustryCategory.bind(this)}
                                                                            options={this.state.industryCategoryList}
                                                                            placeholderButtonLabel="Select [Industry Category]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            {this.state.object_type=='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Service Type </label>
                                                    <ServiceFilter ref="serviceFilter" onSelectService = {this.handleService} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            {/*<div className="col-md-3">*/}
                                            {/*    <label><input type="checkbox" name="is_void"*/}
                                            {/*                  onChange={this.handleCheckVoid.bind(this)}*/}
                                            {/*                  checked={(this.state.is_void == 1) ? true : false}/> &nbsp; Show*/}
                                            {/*        prim id</label>*/}
                                            {/*</div>*/}

                                            {/*<div className="col-md-2 filter-bottom5 padd-5 padd30">*/}
                                            {/*    <label><input type="checkbox" name="is_posbillinput"*/}
                                            {/*                  onChange={this.handleCheckPosBill.bind(this)}*/}
                                            {/*                  checked={(this.state.is_posbillinput == 1) ? true : false}/> &nbsp;  POSBILLINPUT</label>*/}
                                            {/*</div>*/}
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_genie_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this._downLoadGenieTraReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="GinieTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Merchant</th>
                                                <th width="150px">Chain</th>
                                                <th width="150px">Store</th>
                                                <th width="200px">Store Address 1</th>
                                                <th width="200px">Store Address 2</th>
                                                <th>City</th>
                                                <th width="80px">State</th>
                                                <th>Product Amount</th>
                                                <th>Sale Amount</th>
                                                <th>Transaction Amount</th>
                                                <th>Loan Amount</th>
                                                <th>EMI Amount</th>
                                                <th>Instant Discount/Cashback</th>
                                                <th>No Cost EMI Amount</th>
                                                <th>Additional Cashback</th>
                                                <th>Genie Coupon Discount</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Bin No</th>
                                                <th>Acquiring Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Tender Mode</th>
                                                <th>Scheme</th>
                                                <th>Grade</th>
                                                <th>Credit/Debit</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Is DCC Transaction</th>
                                                <th>Is International Card</th>
                                                <th>Transaction Medium</th>
                                                <th>Software Version</th>
                                                <th>Terminal Serial Number</th>
                                                <th>Bill Invoice Number</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Brand</th>
                                                <th>Model</th>
                                                <th>Merchant SKU</th>
                                                <th>Category</th>
                                                <th>Service Type</th>
                                                <th>Innoviti Convenience Fee</th>
                                                <th>Industry Category</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>

                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(GenieTransactionReport)